import { MagnifyIcon } from '@atgfr8/icons';
import { SelectInputCustom } from '@components/Select';
import {
  fetchOrderTemplateData,
  orderStore,
  setOrderStore,
} from '@store/orders';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { createEffect, createMemo, createSignal } from 'solid-js';

export type MenuItemType = {
  label: string;
  value: number;
  disabled?: boolean;
};

let inputRef: HTMLInputElement | undefined;

export const SelectTemplate = (props: { disabled?: boolean }) => {
  const [orderTemplates, setOrderTemplates] = createSignal<MenuItemType[]>([]);
  const [searchTerm, setSearchTerm] = createSignal('');
  const templates = () =>
    Array.isArray(orderStore.orderTemplates) ? orderStore.orderTemplates : [];

  createEffect(() => {
    if (orderTemplates().length === 0 && templates().length > 0) {
      setOrderTemplates(
        templates().map((template) => ({
          label: template.name,
          value: template.id,
        })),
      );
    }
  });

  const handleTemplateSelect = async (templateId: number) => {
    setOrderStore('isCreate', true);
    setSearchTerm('');
    if (inputRef) {
      inputRef.value = '';
    }
    await fetchOrderTemplateData(templateId);
  };

  const filteredTemplates = () => {
    const search = searchTerm().toLowerCase();
    const items = orderTemplates();
    if (!search) return items;
    return items.filter((item) => item.label.toLowerCase().includes(search));
  };

  const searchMenuItem = createMemo(() => ({
    value: '__search__',
    disabled: true,
    class: 'p-0! pointer-events-auto! cursor-default!',
    label: (
      <div
        class="flex items-center mx-2 w-[calc(100%-20px)] p-2 border border-[#1b668f] rounded-sm mt-2 relative"
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      >
        <input
          class="flex-1 w-full outline-hidden focus:ring-0"
          type="text"
          ref={inputRef}
          placeholder="Search Template"
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => {
            event.stopPropagation();
          }}
          onInput={(event) => {
            setSearchTerm(event.currentTarget.value);
          }}
        />
        <div class="flex items-center justify-center w-6 h-6">
          <MagnifyIcon size={16} class="text-gray-500" />
        </div>
      </div>
    ),
  }));

  const menuItems = () => [
    searchMenuItem(),
    ...filteredTemplates().map((item) => ({
      label: item.label,
      value: String(item.value),
      disabled: item.disabled,
    })),
  ];

  return (
    <div class="w-full">
      <SelectInputCustom
        label="Select a Template"
        class="text-[14px] bg-white min-w-[200px]"
        disabled={props.disabled}
        value=""
        placeholder="Select a Template"
        renderValue={() => 'Select a Template'}
        menuItems={menuItems()}
        onChange={(value) => {
          void handleTemplateSelect(parseInt(value));
        }}
        dataTestId={formatDataTestId('order-template', 'selectInput')}
        menuClass="min-w-[320px]"
      />
    </div>
  );
};
